import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";

export const Field = ({ label, children, className = "" }) => (
  <div className={className}><Label className="text-xs text-slate-500">{label}</Label><div className="mt-1">{children}</div></div>
);

import { HelpBox } from "@/components/admin/HelpBox";

export const PageTitle = ({ title, sub, right, help }) => (
  <>
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div><h1 className="font-serif text-3xl sm:text-4xl font-semibold" data-testid="admin-page-title">{title}</h1>{sub && <p className="text-sm text-slate-500 mt-1">{sub}</p>}</div>
    {right}
  </div>
  {help && <HelpBox topic={help} />}
  </>
);

export const AdminButton = ({ variant = "solid", className = "", ...p }) => (
  <button {...p} className={`inline-flex items-center justify-center gap-2 h-10 px-4 rounded-full text-sm font-semibold transition-[opacity,transform] active:scale-[.97] disabled:opacity-50 ${variant === "solid" ? "bg-bp text-white hover:opacity-90" : variant === "danger" ? "text-rose-600 hover:bg-rose-50" : "border bg-white hover:bg-slate-50"} ${className}`} />
);

export function useList(url, params) {
  const [items, setItems] = useState(null);
  const key = JSON.stringify(params || {});
  const reload = useCallback(() => api.get(url, { params: JSON.parse(key) }).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e))), [url, key]);
  useEffect(() => { reload(); }, [reload]);
  return [items, reload];
}

export async function saveDoc(path, doc) {
  try {
    const { data } = doc.id ? await api.put(`${path}/${doc.id}`, doc) : await api.post(path, doc);
    toast.success("Saved");
    return data;
  } catch (e) {
    toast.error(errMsg(e));
    return null;
  }
}
